import React, { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faMagnifyingGlass } from "@fortawesome/free-solid-svg-icons";
import { useTranslation } from "react-i18next";
import { useTheme } from "../../context/ThemeContext";
import useSearch from "../../hooks/useSearch";
import SearchResults from "./SearchResults";

export default function SearchBar() {
  const { t } = useTranslation();
  const { theme } = useTheme();
  const isLight = theme === 'light';
  const [query, setQuery] = useState("");
  const { results, clear } = useSearch(query);

  const handleClear = () => {
    setQuery("");
    clear();
  };

  return (
    <div className="tw-relative tw-flex tw-items-center">
      <div className={`tw-flex tw-items-center tw-gap-2 tw-rounded-full tw-border tw-border-[#FF43A7]/30 tw-px-3 tw-py-1.5 tw-transition-all focus-within:tw-border-[#FF43A7]/70 focus-within:tw-shadow-[0_0_10px_rgba(255,67,167,0.15)] tw-w-36 lg:tw-w-52 ${isLight ? 'tw-bg-white' : 'tw-bg-[#1C0039]/80'}`}>
        <FontAwesomeIcon
          icon={faMagnifyingGlass}
          className="tw-text-[#FF43A7] tw-text-xs tw-flex-shrink-0"
        />
        <input
          type="text"
          value={query}
          onChange={(e) => setQuery(e.target.value)}
          placeholder={t("Search...")}
          className="tw-flex-1 tw-bg-transparent tw-border-0 tw-ring-0 focus:tw-outline-none focus:tw-ring-0 tw-text-sm tw-text-white placeholder:tw-text-white/30 tw-min-w-0"
        />
      </div>

      {results.length > 0 && (
        <SearchResults
          results={results}
          onSelect={handleClear}
          className="tw-right-0 tw-w-72 tw-max-h-72"
        />
      )}
    </div>
  );
}
